/**
 * "1st"/"2nd"/"3rd"/"4th…" — handles the 11/12/13 exception (11th, not 11st). Shared by
 * `PackLandingTemplate.tsx` (copy spec §3 state C CTA, "Queued — {n}th in line") and
 * `TrainingBand.tsx` (queue tray thumb aria-label) — both render the same queue-position suffix;
 * a hand-rolled ternary in the second call site was naive (missed the 11/12/13 exception, masked
 * today by the queue tray's cap of 3) until this extraction.
 */
export function ordinal(n: number): string {
    const rem10 = n % 10
    const rem100 = n % 100
    if (rem10 === 1 && rem100 !== 11) return `${n}st`
    if (rem10 === 2 && rem100 !== 12) return `${n}nd`
    if (rem10 === 3 && rem100 !== 13) return `${n}rd`
    return `${n}th`
}
